<template>
	<span class="whaatFlotig">
	<div class=" position-absolute text-right floating-action-menu" :class="[{'active' : collapsed}]" style="bottom: 10px; right: 10px;" >
	  <div class="action-menu ">
		<div class="floating-action">
			<b-button  variant="dark" pill class="mr-2 reg" href="/register/seller" >Seller? Register Here</b-button>
		  <!--<div class="badge badge-dark">Seller? Register Here</div>
		  <a class="btn-floating btn-sm btn-secondary" href="/register/seller"><i class="fa fa-plus"></i></a> -->
		</div>
		<div class="floating-action">
			<b-button  variant="dark" pill class="mr-2 reg" href="/register/sales-advisor">Sales Advisor? Register Here</b-button>
		 <!--  <div class="badge badge-dark">Sales Advisor? Register Here</div>
		  <a class="btn-floating btn-sm btn-success" href="/register/sales-advisor"><i class="fa fa-save"></i></a>-->
		</div>
	  </div>
	  <div class="d-block action-button"> 
		<button class="btn-floating btn-primary" v-b-tooltip.hover title="Chat Now!">
			<b-link :href="urlWhatapp" target="_blank"><b-img class="waimg" :src="$root.MEDIAPATH+'images/whatsapp-chat.png'"></b-img></b-link>
		</button>
		<!--<button class="btn-floating" style="border: 0px;" >
			<b-link :href="urlWhatapp" target="_blank"><b-img class="waimg" :src="$root.MEDIAPATH+'images/whatsapp-chat.png'"></b-img></b-link>
		
		</button> -->
	  </div>
	</div>
	</span>
</template>
<script> 
/* const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
}; */
	//var today 	= new Date();
	//var timenow = '?'+today.getHours()+ today.getMinutes()+today.getSeconds();
	
export default {
  name: 'MenuPanel',
  components: {
  
  },
  props: {
   
  },
  mounted(){
  //this.inLodcard;
  if(window.innerWidth < 700){
	//this.urlWhatapp='https://wa.me/send?text=&phone=918920670756';
	this.urlWhatapp='https://api.whatsapp.com/send?text=&phone=918920670756';
 }
  
	
  },
  computed: {
    //
  },
  data() {
    return{
     collapsed: false,
	 urlWhatapp:'https://web.whatsapp.com/send?text=&phone=918920670756',

    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
	onToggleCollapse() {
			/* console.log('Ram Ram'+collapsed);
			this.collapsed = collapsed; */
			console.log('DataR'+this.collapsed);
			
			 if(this.collapsed){
				this.collapsed = false;
				
			 }else{
				this.collapsed = true;
				
			 }
			
			 /*this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }*/
		},
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	.whaatFlotig{
		.btn-primary{
			
			width: 35px;
			height: 35px;
			position: fixed;
			border-radius: 50%;
			bottom: 10px;
			right: 2%;
			border: 0px;
			z-index: 9;
			color: red;
			background: #fff;
			border: 1px solid #010e1d;
			img{
				width: 31px;
				margin-left: -4px;
				background: #fff;
				border-radius: 50%;
			}
				 
		}
		
		.floating-action{
			margin: 10px 0px;
		}
		.btn-dark{
			font-size: 10px;
		}
		
		div.floating-action-menu.active > .action-menu{
			visibility: visible;
			transform: translate(0);
			opacity: 1;
			padding-bottom: 5px;
			max-height: 1000px;
			position: fixed;
			bottom: 41px;
			right: 0px;
			z-index: 999;
		}
		.iconPuser{
			font-size:20px;
		}
	
	
	
	
	div.floating-action-menu.active > .action-button > .btn-floating:hover {
			/*background-color: red;
			border-color: #ff4c3b;*/
			
			color: #fff;
		}
		div.floating-action-menu.active > .action-button > .btn-floating {
			
			color: #fff;
		}
		
		
		.btn-primary:focus{
			box-shadow: none;
		}
	
	
	}
	div.floating-action-menu > .action-menu {
            visibility: hidden;
            transform: translateY(65px);
            opacity: 0;
            max-height: 0;
            overflow: hidden;

            transition: all 300ms linear;
        }
        div.floating-action-menu.active > .action-menu {
            visibility: visible;
            transform: translate(0);
            opacity: 1;
            padding-bottom: 5px;
            max-height: 1000px;
        }

        div.floating-action-menu > .action-menu > .floating-action {
            padding-right: 0.45rem;
        }

        div.floating-action-menu > .action-menu .btn-floating,
        div.floating-action-menu > .action-menu .badge
        {
            transform: scale(0.4);
            transition: all 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-menu .btn-floating,
        div.floating-action-menu.active > .action-menu .badge
        {
            transform: scale(1);
        }

        div.floating-action-menu > .action-button > .btn-floating {
            transition: all 500ms linear;
        }
        div.floating-action-menu.active > .action-button > .btn-floating {
            background-color: #dc3545;
            border-color: #dc3545;
        }
        div.floating-action-menu.active > .action-button > .btn-floating:hover {
            background-color: #c82333;
            border-color: #bd2130;
        }

        div.floating-action-menu > .action-button > .btn-floating > i {
            transition: transform 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-button > .btn-floating > i {
            transform: rotate(-315deg);

        }
	/*.waimg{    
	width: 41px;
    margin-top: -31px;
    position: fixed;
    right: 17px;
	    border: 1px solid #3d225c1c;
    border-radius: 50%;
    padding: 1px;
    background: #fff;
	box-shadow:0px 1px 10px #68358173;
	} */


</style>
